// ============================================================
// Lógica de ramificación (skip logic) compartida.
// La consumen el frontend (flujo) y el backend (validación).
// ============================================================
import { CHAPTERS, QUESTIONS } from './data.js';
/** Opciones efectivas de una pregunta `single` (resuelve `optionsFn`). */
export function getOptions(q, answers) {
    if (q.type !== 'single')
        return [];
    if (q.optionsFn)
        return q.optionsFn(answers);
    return q.options ?? [];
}
/** ¿La pregunta es visible dadas las respuestas actuales? */
export function isVisible(q, answers) {
    return !q.condition || q.condition(answers);
}
/** Preguntas visibles, en orden, dadas las respuestas actuales. */
export function visibleQuestions(answers) {
    return QUESTIONS.filter((q) => isVisible(q, answers));
}
/**
 * Elimina las respuestas de preguntas que ya no son visibles (huérfanas
 * de la ramificación). Se aplica antes del envío: el backend rechaza
 * respuestas a preguntas cuya condición no se cumple (README §8).
 *
 * Itera a punto fijo porque quitar una respuesta puede cambiar la
 * visibilidad de otra pregunta más abajo (p. ej. q33b → q33c).
 */
export function pruneAnswers(answers) {
    let current = { ...answers };
    for (;;) {
        const visible = new Map(visibleQuestions(current).map((q) => [q.id, q]));
        const next = {};
        let changed = false;
        for (const key of Object.keys(current)) {
            const value = current[key];
            const q = visible.get(key);
            const empty = value === undefined || value === null || value === '';
            // Una respuesta `single` con opciones dinámicas (optionsFn) puede quedar
            // inválida si cambia la respuesta de la que depende (p. ej. q4/curso al
            // cambiar q3/nivel). En ese caso también se descarta.
            const invalidOption = q?.type === 'single' &&
                typeof value === 'string' &&
                !getOptions(q, current).includes(value);
            if (q && !empty && !invalidOption) {
                next[key] = value;
            }
            else {
                changed = true;
            }
        }
        current = next;
        if (!changed)
            return current;
    }
}
/**
 * Construye la lista de pantallas visibles (transiciones + preguntas + envío)
 * según las respuestas. Espejo de `buildSteps` del prototipo.
 */
export function buildSteps(answers, showTransitions = true) {
    const steps = [];
    for (const ch of CHAPTERS) {
        const qs = QUESTIONS.filter((q) => q.chapter === ch.id && isVisible(q, answers));
        if (qs.length === 0)
            continue;
        if (showTransitions)
            steps.push({ kind: 'transition', chapter: ch });
        qs.forEach((q, i) => steps.push({ kind: 'question', chapter: ch, question: q, qIndex: i, qTotal: qs.length }));
    }
    const last = CHAPTERS[CHAPTERS.length - 1];
    if (last)
        steps.push({ kind: 'send', chapter: last });
    return steps;
}
//# sourceMappingURL=logic.js.map